<template>
  <div>
    <v-item-group
      class="d-flex flex-wrap mt-3"
      style="gap: 10px"
      v-model="activeItem"
      active-class="primary--text"
    >
      <v-item
        v-slot="{ active, toggle }"
        v-for="(sol, index) in solicitudesSorted"
        :key="index"
        :value="sol.CodigoContrato"
      >
        <v-card
          @click.stop="toggle"
          :outlined="active"
          width="200"
          height="200"
          class="pa-2 d-flex flex-column justify-space-between"
          :loading="!sol.IdSolicitud"
        >
          <div class="d-flex justify-space-between mb-n6">
            <v-tooltip v-if="sol.CodigoREE" bottom color="info">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  label
                  small
                  text
                  color="info"
                  class="pa-1 font-weight-bold"
                  style="min-width: unset"
                  >{{ sol.CodigoREE }}</v-btn
                >
              </template>
              {{ sol.NombreFiscal }}
            </v-tooltip>
            <v-tooltip v-if="!Number(sol.impagosActivos)" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="float-right"
                  color="warning"
                  v-bind="attrs"
                  v-on="on"
                  >mdi-alert-outline</v-icon
                >
              </template>
              Sin impagos, anular
            </v-tooltip>
          </div>
          <h3 class="text-center">{{ sol.CodigoContrato }}</h3>
          <div class="d-flex flex-column align-center">
            <v-chip
              v-if="sol.fecha"
              small
              label
              outlined
              class="text-center text-caption"
              >{{ sol.fecha }}</v-chip
            >
            <!-- <v-chip
              v-if="sol.fechaEfecto"
              small
              label
              outlined
              class="text-center text-caption"
              >{{ sol.fechaEfecto }}</v-chip
            > -->
          </div>
          <p class="text-center text-caption text--secondary mb-0 pa-0">
            {{
              sol.RazonSocial ||
                [sol.Nombre, sol.Apellido1, sol.Apellido2]
                  .filter((x) => !!x)
                  .join(" ")
            }}
          </p>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="!sol.anulacion && sol.IdSolicitud"
              @click.stop="anularCorte(sol)"
              color="warning"
              text
              small
              >Solicitar anulación</v-btn
            >
            <v-btn
              v-else-if="sol.anulacion && sol.IdSolicitud"
              @click.stop="anularAnulacion(sol)"
              plain
              small
              color="info"
              >Anulación solicitada</v-btn
            >
            <v-btn
              v-else-if="sol.IdSolicitudPropia && !sol.IdSolicitud"
              @click.stop="anularAnulacion(sol)"
              text
              small
              color="error"
              >Eliminar solicitud</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-item>
      <v-item>
        <v-dialog scrollable max-width="700">
          <template v-slot:activator="{ on, attrs }">
            <v-card
              v-on="on"
              v-bind="attrs"
              outlined
              style="border-width: 3px; border-style: dashed; background: transparent"
              width="200"
              height="200"
              class="pa-2 d-flex flex-column justify-center align-center"
            >
              <v-btn x-large icon>
                <v-icon x-large>mdi-plus</v-icon>
              </v-btn>
            </v-card>
          </template>
          <NuevaSolicitudCorte @reload="$emit('reload')" />
        </v-dialog>
      </v-item>
    </v-item-group>
    <ConfirmDialog ref="confirm" />
  </div>
</template>

<script>
import { parseDate } from "@/utils/index.js";

export default {
  props: {
    solicitudes: Array,
  },
  components: {
    NuevaSolicitudCorte: () => import("../components/NuevaSolicitudCorte.vue"),
    ConfirmDialog: () => import("@/components/ConfirmDialog.vue"),
  },
  methods: {
    parseDate,
    async anularCorte(sol) {
      const r = await this.$refs.confirm.open(
        `¿Estás seguro de que quieres solicitar la anulación del corte?`,
        ``,
        { color: "error", confirmColor: "error", width: 600 }
      );
      if (!r) return;

      axios({
        url: `${process.env.VUE_APP_OUR_API_URL}/solicitudesCorte.php`,
        method: "PUT",
        data: {
          token: this.$store.getters.getJwtEmpresa,
          solicitudes: [
            {
              CodigoContrato: sol.CodigoContrato,
              anulacion: 1,
              corte: 1,
            },
          ],
        },
      })
        .then((res) => {
          this.$root.$emit(
            "snack",
            "Se ha enviado la solicitud de anulación del corte"
          );
          this.$emit("reload");
        })
        .catch((err) => {
          console.error(err);
          this.$root.$emit(
            "snack",
            "No se ha podido enviar la solicitud de anulación del corte"
          );
        });
    },
    async anularAnulacion(sol) {
      const r = await this.$refs.confirm.open(
        `¿Estás seguro de que quieres solicitar que continue el corte?`,
        ``,
        { color: "error", confirmColor: "error", width: 600 }
      );
      if (!r) return;

      axios({
        url: `${process.env.VUE_APP_OUR_API_URL}/solicitudesCorte.php`,
        method: "DELETE",
        data: {
          token: this.$store.getters.getJwtEmpresa,
          IdSolicitudPropia: sol.IdSolicitudPropia,
        },
      })
        .then((res) => {
          this.$root.$emit(
            "snack",
            "Se ha enviado la solicitud de continuación del corte"
          );
          this.$emit("reload");
        })
        .catch((err) => {
          console.error(err);
          this.$root.$emit(
            "snack",
            "No se ha podido enviar la solicitud de continuación del corte"
          );
        });
    },
  },
  data() {
    return {
      activeItem: null,
    };
  },
  computed: {
    solicitudesSorted() {
      return this.solicitudes.sort(
        (a, b) =>
          parseDate(a.FechaPrevistaActivacion, true) -
          parseDate(b.FechaPrevistaActivacion, true)
      );
    },
  },
  watch: {
    activeItem(n) {
      this.$emit("filter", n || null);
    },
  },
};
</script>
